<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
      @closeDialog="closeDialog"
    ></page-template>
    <!--<add-form ref="addFormOptions" @submit="upgradePwd"></add-form>-->
  </div>
</template>
<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  import addForm from "@/components/template/add";

  export default {
    mixins: [userPower],
    components: {
      pageTemplate,
      addForm
    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              isHasAll: true,
              data: [],
              url: api.store.store,
            },
            // {
            //   label: "门店名称",
            //   type: "select",
            //   prop: "storeId",
            //   data: [],
            //   url: api.system.seStore
            // },
            // {label: '登陆账号', prop: 'loginName', type: 'input', isFuzzy: true, placeholder: "请输入登陆账号"},
            {label: '', prop: 'otherName', type: 'input', isFuzzy: true, placeholder: "请输入工号/姓名"},
            {
              label: "在职状态",
              type: "select",
              prop: "status",
              data: this.$utils.getCacheStatus('sysGuideMap.status'),
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: "添加",
            code: 'insert',
          },
          {
            label: "编辑",
            code: 'update',
            type: this.$utils.buttonType.tableOperate
          },
          {
            label: "删除",
            code: "delete",
            type: this.$utils.buttonType.tableOperate
          },
          // {
          //   label: '修改密码',
          //   code: 'updatePassword',
          //   callback: this.updatePassword
          // }
        ],
        // 表格信息配置
        tableOptions: {
          // param: {type: 50},
          indexShow: true,//是否显示索引
          columns: [
            // {
            //   label: "登陆账号",
            //   prop: "loginName",
            //   width: "120",
            //   align: "center"
            // },
            {
              label: '门店',
              prop: 'storeName',
              width: '150',
              align: 'center'
            },
            {label: "姓名", prop: "name", width: "120", align: "center"},
            {label: "工号", prop: "code", width: "120", align: "center"},
            {label: "在职状态", prop: "status", width: "120", align: "center",enumData: this.$utils.getCacheStatus('sysGuideMap.status')},
            {
              label: "提成方式",
              prop: "commissionName",
              width: "140",
              align: "center",
            },
            // {
            //   label: '提成率',
            //   prop: 'commissionRate',
            //   width: '120',
            //   align: 'center'
            // },
            // {
            //   label: "状态",
            //   prop: "status",
            //   width: "100",
            //   align: "center",
            //   enumData: this.$utils.getCacheStatus('sysUser.status')
            // },
            {
              label: '创建时间',
              prop: 'createDttm',
              width: '150',
              align: 'center'
            },
            // {
            //   label: '创建人',
            //   prop: 'createBy',
            //   width: '150',
            //   align: 'center'
            // }
          ],
          url: api.system.guide
        },
        // 添加字段
        addColumns: {
          labelWidth: "120px",
          span: 12,
          // param: {type: 50},
          columns: [
            // {
            //   label: "登陆账号",
            //   type: "code",
            //   prop: "loginName",
            //   isButtonShow: false,
            //   tipsInfo: '登录账号重复请重新输入！',
            //   checkUrl: api.system.account + "/check/login/name",
            //   rule: [
            //     {required: true, message: "请输入登陆账号", trigger: "blur"},
            //     {
            //       min: 2,
            //       max: 15,
            //       message: "长度在 2 到 15 个字符",
            //       trigger: "blur",
            //     },
            //   ],
            // },
            // {
            //   label: "登录密码",
            //   type: "password",
            //   prop: "passwordPlaintext",
            //   rule: [
            //     {required: true, message: "请输入密码", trigger: "blur"},
            //   ],
            // },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              isHasAll: true,
              data: [],
              url: api.store.store,
              rule: [
                {required: true, message: "请选择门店", trigger: "blur"},
              ],
              change:this.changeStore,
            },
            {
              label: "姓名",
              type: "input",
              prop: "name",
              rule: [
                {required: true, message: "请输入姓名", trigger: "blur"},
              ],
            },
            {
              label: "工号",
              type: "code",
              prop: "code",
              isButtonShow: false,
              tipsInfo: '工号重复请重新输入！',
              // checkUrl: api.system.account + "/check/login/name",
              checkUrl: api.system.guide + "/check/code",
              rule: [
                {required: true, message: "请输入工号", trigger: "blur"},
                {
                  min: 2,
                  max: 15,
                  message: "长度在 2 到 15 个字符",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "提成方式",
              type: "select",
              prop: "commissionId",
              data: []
            },
          ],
          url: api.system.guide
        },
        // 添加字段
        editColumns: {
          labelWidth: "120px",
          span: 12,
          // param: {type: 50},
          columns: [
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              isHasAll: true,
              data: [],
              url: api.store.store,
              disabled:true,
            },
            {
              label: "姓名",
              type: "input",
              prop: "name",
              rule: [
                {required: true, message: "请输入姓名", trigger: "blur"},
              ],
            },
            {
              label: "工号",
              type: "input",
              prop: "code",
              disabled: true
            },
            {
              label: "在职状态",
              type: "select",
              prop: "status",
              data: this.$utils.getCacheStatus('sysGuideMap.status'),
              change:this.toEditPage,
            },
            {
              label: "提成方式",
              type: "select",
              prop: "commissionId",
              data: []
            },
          ],
          url: api.system.guide
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.simple);
      this.setStore(this.addColumns.columns);
      this.getCommission();
    },
    methods: {
      // 关闭弹框
      closeDialog(){
        this.addColumns.columns.filter(item => item.prop === 'commissionId')[0].data = [];
        this.editColumns.columns.filter(item => item.prop === 'commissionId')[0].data = []
      },
      //选择门店
      changeStore(form){
        form.commissionId = ''
        this.$axios.fetchPost('/api/eros/cs/csCommissionScheme/list', {status: 10,storeId:form.storeId}).then(data => {
          if (data.code === 200) {
            this.addColumns.columns.filter(item => item.prop === 'commissionId')[0].data = data.data;
          } else {
            this.$message({message: "请求失败", type: "error"})
          }
        })
      },
      getCommission() {
        let userInfo = this.$utils.getSysUser();
        this.$axios.fetchPost('/api/eros/cs/csCommissionScheme/list', {status: 10,storeId:userInfo.storeId}).then(data => {
          if (data.code === 200) {
          this.addColumns.columns.filter(item => item.prop === 'commissionId')[0].data = data.data;
        } else {
          this.$message({message: "请求失败", type: "error"})
        }
      })
      },
      toEditPage(form){
        this.$axios.fetchPost('/api/eros/cs/csCommissionScheme/list', {status: 10,storeId:form.storeId}).then(data => {
          if (data.code === 200) {
          this.editColumns.columns.filter(item => item.prop === 'commissionId')[0].data = data.data;
        } else {
          this.$message({message: "请求失败", type: "error"})
        }
      })
      }
      // commissionTypeChange(formModel) {
      //   let commissionRateAdd = this.addColumns.columns.filter(item => item.prop == 'commissionRate')[0];
      //   let commissionRateEdit = this.editColumns.columns.filter(item => item.prop == 'commissionRate')[0];
      //   if (formModel.commissionType == 20) {
      //     commissionRateAdd.rule = [];
      //     commissionRateAdd.disabled = true;
      //     formModel.commissionRate = '';
      //   } else {
      //     commissionRateAdd.rule = [{required: true, message: "请输入提成率", trigger: "blur"}];
      //     commissionRateAdd.disabled = false;
      //   }
      // },
      // updatePassword(row) {
      //   this.changePwdDialog.formData = row;
      //   this.$nextTick(() => {
      //     this.addColumns && this.$store.commit(this.$utils.storeKeys.OTHERFORM, this.changePwdDialog);
      //     this.$refs['addFormOptions'].setFormOptions('other', row.id, '修改密码');
      //   })
      // },
      // upgradePwd(data) {
      //   let params = {id: data.id, newPassword: data.newPassword};
      //   this.$axios.fetchPost(api.system.account + "/password" + `?${this.$utils.JSONToString(params)}`, {}).then(result => {
      //     if (result.code === 200) {
      //       this.$message({type: 'success', message: '修改成功!'});
      //     } else {
      //       this.$message({type: 'error', message: result.msg});
      //     }
      //   }).catch(err => {
      //     this.$message({type: 'error', message: '修改失败!'});
      //   })
      // },
    }
  };
</script>




// WEBPACK FOOTER //
// src/page/retail/Salesman.vue